
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { defineComponent, ref, onBeforeUnmount, onMounted } from "vue";

import Quote from "@/components/Quote/Quote.vue";
import SocialMedia from "@/components/SocialMedia/SocialMedia.vue";
import { getImgUrl } from "@/helpers/getImage";

export default defineComponent({
  name: "HomeView",
  components: { FontAwesomeIcon, Quote, SocialMedia },
  setup() {
    const headerRotation = ref(false);

    const socialMedias = [
      {
        id: "LinkedIn",
        faIcon: "fab fa-linkedin-in",
        url: "https://www.linkedin.com/in/brenda-cayzac-138297103/",
        text: "/brenda-cayzac",
      },
      {
        id: "Behance",
        faIcon: "fa-brands fa-behance",
        url: "https://www.behance.net/brendacayzac",
        text: "/brendacayzac",
      },
      {
        id: "GitHub",
        faIcon: "fa-brands fa-github",
        url: "https://github.com/BrendaCayzac",
        text: "/BrendaCayzac",
      },
      {
        id: "Twitter",
        faIcon: "fa-brands fa-twitter",
        url: "https://twitter.com/BrendaCayzac",
        text: "@BrendaCayzac",
      },
    ];

    const information = [
      {
        src: "web_design",
        srcAlt: "Example of",
        title: "development",
        text: "development-information",
        link: "https://github.com/BrendaCayzac?tab=repositories",
      },
      {
        src: "Jacques_reveal",
        srcAlt: "Example of",
        title: "illustration",
        text: "illustration-information",
        link: "/commissions",
      },
      {
        src: "graphic_design",
        srcAlt: "Example of",
        title: "graphic-design",
        text: "graphic-design-information",
        link: "https://www.behance.net/brendacayzeb7a",
      },
      {
        src: "motion_graphics",
        srcAlt: "Example of",
        title: "Motion graphics",
        text: "motion-graphics-information",
        link: "/portfolio",
      },
    ];

    const handleScroll = () => {
      headerRotation.value = window.scrollY > 30;
      const categories = document.querySelector(".categories");

      if (categories && window.scrollY > 30) {
        categories.classList.add("align-right");
      } else if (categories && window.scrollY < 30) {
        categories.classList.remove("align-right");
      }
    };

    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("scroll", handleScroll);
    });

    return {
      getImgUrl,
      headerRotation,
      information,
      socialMedias,
    };
  },
});
